import { motion } from "framer-motion";

/**
 * Small "field-guide" chapter tag: a short rule + monospaced-feeling caps.
 * Meant to sit at the very top of each landing section so the whole page
 * reads like a printed dossier being turned page by page.
 */
export default function ChapterMark({ n, title, variant = "light", className = "" }) {
  const isDark = variant === "dark";
  const line = isDark ? "bg-white/25" : "bg-black/25";
  const num = isDark ? "text-[#c9a961]" : "text-[#a3823f]";
  const label = isDark ? "text-white/60" : "text-black/60";
  const sep = isDark ? "text-white/25" : "text-black/25";

  return (
    <motion.div
      data-testid={`chapter-mark-${n}`}
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`flex items-center gap-3 ${className}`}
    >
      <span className={`h-px w-8 ${line}`} />
      <span className={`text-[10px] uppercase tracking-[0.35em] font-medium ${num}`}>Ch. {n}</span>
      <span className={`text-[10px] ${sep}`}>·</span>
      <span className={`text-[10px] uppercase tracking-[0.35em] ${label}`}>{title}</span>
    </motion.div>
  );
}
